<template>
    <div v-show="show">
        <div id="graphic-board-background">
            <div class="title">
                <input id="txt-title" type="text" v-model="title" @input="checkTitleLength" placeholder="圖文畫板" />
                <p class="title-prompt" v-show="showTitlePrompt">{{ titlePrompt }}</p>
            </div>
            <div ref="contentCanvas" class="content">
                <canvas id="graphic-board-canvas" width="1447" height="767"></canvas>
            </div>
            <div class="tools">
                <div class="tool-button" v-for="tool in toolsFilter" @click="triggerTool(tool.TOOL)">
                    <span>{{ tool.TOOL_NAME }}</span>
                </div>
            </div>
            <div class="buttons">
                <div class="action-button" @click="handleDelete">
                    <img res="stickyDelete" src="../../assets/other_tools/common/delete.svg" />
                    <span>刪除</span>
                </div>
                <div class="action-button" @click="closeBoard">
                    <img res="stickySave" src="../../assets/other_tools/common/confirm.svg" />
                    <span>確認</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PainterProxy from '../../js/painter/proxy';
import GraphicBoardProxy from '../../js/painter/graphic_board_proxy';
import { TOOLS, NO_STOP_POLYGON_TOOLS, ALIVE_TYPE } from '../../js/toolbar/tools';
import { store } from '../../store';
import EventBus from '../../js/event_bus';
import { focusStore } from '../../js/store/nowFocusStore';
import { DEBOUNCE } from '../../js/common/debounce';
import { CHECK_INPUT_CHAR } from '../../js/common/check_char';
import PromptDialog from '../dialogs/PromptDialog.vue';
import { VIEW_TYPE } from '../../js/view_type';
export default {
    name: "GraphicBoard",
    data() {
        return {
            show: false,
            title: "",
            tools: [TOOLS.IMAGE, TOOLS.TEXT_BOX, TOOLS.STAMP],
            id: "",
            currentBoard: null,
            checkTitleLength: null,
            showTitlePrompt: false,
            titlePrompt: "限10字元"
        }
    },
    methods: {
        openBoard() {
            this.show = true;
            this.setCurrentPainter();
            focusStore.setEmptyPageItemControl("graphicBoard");
            focusStore.setFocusBookPage(this);
            this.showTitlePrompt = false;
        },
        closeBoard() {
            GraphicBoardProxy.Instance.currentPainter.canvas.discardActiveObject();

            this.show = false;
            GraphicBoardProxy.Instance.saveGraphicBoardPainter(this.id);
            // console.log(GraphicBoardProxy.Instance.currentPainter);

            // this.handleTextBoxClose(GraphicBoardProxy.Instance.currentPainter.canvas);

            PainterProxy.getInstance().removeCurrentPainter();

            GraphicBoardProxy.Instance.setTitle(this.title);
            focusStore.setNowPageItemControl();
            EventBus.getInstance().getAppRefs().bookPage.focusWindow();

            EventBus.getInstance().getAppRefs().stampBoard.closeBoard();
            PainterProxy.getInstance().getCurrentPainter().painter.addHistory();
        },
        deleteBoard() {
            this.show = false;
            focusStore.setNowPageItemControl();
            PainterProxy.getInstance().removeCurrentPainter(this.id);
            GraphicBoardProxy.Instance.deleteGraphicBoardPainter(this.id);
            EventBus.getInstance().getAppRefs().stampBoard.closeBoard();
        },
        set(title, id, board) {
            this.title = title;
            this.id = id;
            console.log("current id::", this.id);
            this.currentBoard = board;

            PainterProxy.getInstance().clearAll(false, false);

            const save = GraphicBoardProxy.Instance.getGraphicBoardPainter(this.id);

            if(save != null) {
                // TODO: recover
                PainterProxy.getInstance().loadSave(save);
            }
        },
        setCurrentPainter() {
            PainterProxy.getInstance().setCurrentPainter("graphic-board-canvas");    
        },
        triggerTool(tool) {
            this.toolPressed = null;
            console.log("click tool:", tool);
            // console.log(PainterProxy.getInstance().getCurrentPainter().painter.currentTool);
            if (PainterProxy.getInstance().getCurrentPainter().painter.currentTool) {
                let isTrigger = true;
                for (let i = 0; i < NO_STOP_POLYGON_TOOLS.length; i++) {
                    if (NO_STOP_POLYGON_TOOLS[i].TOOL == tool) {
                        isTrigger = false;
                        break;
                    }
                }
                if (isTrigger) {
                    PainterProxy.getInstance().getCurrentPainter().painter.currentTool.mouseDBLClick();
                }
            }
            if (store.toolMap.get(tool)) {
                switch (store.toolMap.get(tool).KEEP_ALIVE) {
                    case ALIVE_TYPE.KEEP:
                        EventBus.getInstance().emit(tool);
                        store.nowTool = tool;
                        store.setPreviousTool(tool);
                        break;
                    case ALIVE_TYPE.ONCE:
                        EventBus.getInstance().emit(TOOLS.SELECTION.TOOL);
                        store.setPreviousTool(TOOLS.SELECTION.TOOL);
                        EventBus.getInstance().emit(tool);
                        store.nowTool = tool;
                        break;
                    case ALIVE_TYPE.NONE:
                        EventBus.getInstance().emit(tool);
                        console.log("prev tool:", store.prevTool);
                        store.nowTool = store.prevTool;
                        break;
                }
            } else {
                EventBus.getInstance().emit(tool);
                store.nowTool = store.prevTool;
            }

            if (tool == TOOLS.TOOL_BOX.TOOL) {
                return;
            }

            if (tool == TOOLS.GO_PAGE.TOOL) {
                return;
            }

            if (tool == TOOLS.WHITE_BOARD.TOOL) {
                store.setWhiteboardDisabledTools();
            }

            EventBus.getInstance().emit("close_tool_box");
            EventBus.getInstance().emit("close_quick_directory");
        },
        handleDelete() {
            EventBus.getInstance().getAppRefs().confirmDialog.showDialog(
                "警告",
                "確定要刪除嗎？",
                this.deleteBoard.bind(this),
                null,
                "刪除",
                "取消"
            );
        },
        handleTextBoxClose(canvas) {
            const objects = canvas.getObjects();
            if(objects.length > 0) {
                objects.forEach(object => {
                    if(object.toolType == "text_box") {
                        object.set({
                            isEditing: false
                        })
                    }
                })

                console.log(objects);
            }
        }
    },
    computed: {        
        toolsFilter() {
            return this.tools
        }
    },
    mounted() {
        const self = this;
        PainterProxy.getInstance().setPainter("graphic-board-canvas", false, true);
        PainterProxy.getInstance().setCurrentPainter("graphic-board-canvas");
        console.log(PainterProxy.getInstance().painterMap.get("graphic-board-canvas"));
        GraphicBoardProxy.Instance.setCurrentPainter(PainterProxy.getInstance().painterMap.get("graphic-board-canvas"));

        this.checkTitleLength = DEBOUNCE(() => {
            const result = CHECK_INPUT_CHAR(self.title, 10);
            self.title = result.substringStr;
            self.showTitlePrompt = !result.pass;
        }, 0);

        this.$refs.contentCanvas;
    },
};
</script>

<style lang="css" src="../../assets/css/GraphicBoard.css" scoped></style>
